import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { BlogPostContext } from "../../services/blogs/blogpost.context";
import { Loader } from "../../components/utilities/loader";

export const BlogRedir = () => {

    const { blogposts, isLoading } = useContext(BlogPostContext);

    const navigateTo = useNavigate();

    const urlParams = new URLSearchParams(window.location.search);

    const cleanImages = (imagesArr) => {
        const splitArr = imagesArr?.split(",");
        const cleanedAr = splitArr?.map((i) => {
            i = i.replace(/]|"|\\|\[/g, "");
            return i;
        });
        const latestImag = cleanedAr?.find((el) => cleanedAr?.indexOf(el) === 0);
        return {
            imgCap: latestImag,
            images: cleanedAr
        }
    }

    useEffect(() => {
        const blog_id = urlParams.get('post_id');
        const thispost = blogposts?.find((blog) => blog.id === parseInt(blog_id));
        const blogImages = cleanImages(thispost?.images);

        if (thispost) {
            navigateTo('/blogdetail', {
                state: {
                    blogData: thispost,
                    images: blogImages?.images
                }
            })
        }

        console.log({
            blogData: thispost,
            images: blogImages
        })

    }, [urlParams, blogposts])

    return (
        <div className="f-pg">
            {isLoading && <Loader />}
        </div>
    );
}